import InstanceApi from "@/services/apiClient.js";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions(["updateCurrentCartRecaps"]),

    async updateCart() {
      try {
        let apiUrlUpdateCart = "mcp/cart/update";
        // ADD PREPEND DATA KEY
        Object.keys(this.preprendCartDataDelivery).forEach(key => {
          if (this.preprendCartDataDelivery[key] !== "") {
            apiUrlUpdateCart = apiUrlUpdateCart + "/" + key + "/" + this.preprendCartDataDelivery[key];
          }
        });

        const response = await InstanceApi.get(apiUrlUpdateCart);
        this.updateCurrentCartRecaps(response.data);
      } catch (error) {
        console.error(error);
      }
    },
  },

  computed: {
    ...mapGetters({
      preprendCartDataDelivery: "getPreprendCartDeliveryData",
    }),
    ...mapGetters({ storeUrlPrefix: "getStoreUrlPrefix" }),
  },
};
